import { mapValues } from 'lodash'
import { LinkAt } from 'valuelink'
import { uniqueEmail, emailExist } from 'helpers/validation'


const validateFields = (linkedFields, validatedFields, fieldValues) =>
  mapValues(linkedFields, (opts, fieldName) => {
    if (opts instanceof LinkAt) {
      if (validatedFields && validatedFields[fieldName] && validatedFields[fieldName].validate) {
        opts.validate.some((validate) => {
          const isAsyncFn = [
            uniqueEmail().toString(),
            emailExist().toString(),
          ]
            .includes(validate.toString())

          // check if validate is async Promise
          // TODO add `isChanged` to all fields to check if field was changed and return true / false
          if (isAsyncFn) {
            opts.error = validatedFields[fieldName].error
          }
          // otherwise call it to check if error was resolved
          else {
            opts.error = validate(opts.value, fieldValues)
          }

          return Boolean(opts.error)
        })
        return opts
      }
      return opts
    }
    return validateFields(opts, validatedFields[fieldName])
  })


export default validateFields
